
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Globe } from 'lucide-react';
import { Shop } from '@/components/dashboard/shops/types';
import AddDomainForm from './domains/AddDomainForm';
import DomainsList from './domains/DomainsList';
import useDomainManagement from './domains/useDomainManagement';

interface CustomDomainsSectionProps {
  shop: Shop;
}

export const CustomDomainsSection: React.FC<CustomDomainsSectionProps> = ({ shop }) => {
  const {
    domains,
    newDomain,
    setNewDomain,
    isLoading,
    isVerifying,
    isDeleting,
    verificationError,
    dnsCheckResult,
    manualVerification,
    addDomain,
    verifyDomain,
    verifyDomainManually,
    deleteDomain,
    getStatusBadge
  } = useDomainManagement(shop);

  return (
    <Card className="col-span-2">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2">
          <Globe className="h-5 w-5" />
          Domaines personnalisés
        </CardTitle>
        <CardDescription>
          Connectez votre boutique à un nom de domaine personnalisé
        </CardDescription>
      </CardHeader>
      
      <CardContent>
        <div className="space-y-6">
          <AddDomainForm
            newDomain={newDomain}
            setNewDomain={setNewDomain}
            addDomain={addDomain}
            isLoading={isLoading}
          />

          <Separator />

          <DomainsList
            domains={domains}
            getStatusBadge={getStatusBadge}
            verifyDomain={verifyDomain}
            verifyDomainManually={verifyDomainManually}
            deleteDomain={deleteDomain}
            isVerifying={isVerifying}
            isDeleting={isDeleting}
            verificationError={verificationError}
            dnsCheckResult={dnsCheckResult}
            manualVerification={manualVerification}
          />
        </div>
      </CardContent>
      
      <CardFooter className="flex justify-between">
        <p className="text-sm text-gray-500">
          Les domaines personnalisés sont inclus dans votre forfait
        </p>
      </CardFooter>
    </Card>
  );
};

export default CustomDomainsSection;
